export type WraAudioState = 'idle' | 'loading' | 'sending' | 'sent' | 'playing' | 'complete' | 'error';

type WraAudioStatusProps = {
  state: WraAudioState;
  message: string;
  className?: string;
};

export default function WraAudioStatus({ state, message, className }: WraAudioStatusProps) {
  if (state === 'idle' || !message) {
    return null;
  }

  const classes = `wra-audio-status wra-audio-status-${state}${className ? ` ${className}` : ''}`;

  if (state === 'error') {
    return <div className={classes} role="alert">{message}</div>;
  }

  return <div className={classes} role="status" aria-live="polite">{message}</div>;
}
